(function(){
  const clean=s=>(s||'').toLowerCase().replace(/[^a-z0-9\s-]/g,' ').replace(/\s+/g,' ').trim();
  const qs=(root,sel)=>root.querySelector(sel);
  const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text)n.textContent=text;return n};

  document.querySelectorAll('[data-k9-lofty]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const launcher=qs(root,'.k9-lofty__launcher'),panel=qs(root,'.k9-lofty__panel'),close=qs(root,'.k9-lofty__close'),log=qs(root,'.k9-lofty__log'),form=qs(root,'.k9-lofty__form'),input=qs(root,'input[type="text"]'),fileInput=qs(root,'.k9-lofty__file-input');
    const knowledge=JSON.parse(qs(root,'[data-k9-lofty-knowledge]').textContent||'[]');
    const locations=JSON.parse(qs(root,'[data-k9-lofty-locations]').textContent||'{}');
    const liveData=JSON.parse(qs(root,'[data-k9-lofty-live]').textContent||'{}');
    const storageKey='k9LoftyConversationV1';
    const state={service:'',location:'',history:[],transcript:[],pendingAvailability:'',pendingFile:null,attachmentStep:'',attachmentDraft:null};
    const attachmentsEnabled=String(root.dataset.attachmentsEnabled||'').toLowerCase()==='true';
    const page={plan:root.dataset.planUrl||'/pages/request-a-visit',vaccines:root.dataset.vaccineUrl||'/pages/vaccine-records',webcams:root.dataset.webcamsUrl||'/pages/webcams',pricing:root.dataset.pricingUrl||'/pages/pricing'};

    function setupAttentionBounce(){
      if(String(root.dataset.attentionBounce||'').toLowerCase()!=='true')return;
      const firstKey='k9LoftyAttentionStartedV1';
      const reminderKey='k9LoftyAttentionReminderV1';
      const reminderDelay=45000;
      const bounce=()=>{
        root.classList.remove('k9-lofty--attention');
        void root.offsetWidth;
        root.classList.add('k9-lofty--attention');
        window.setTimeout(()=>root.classList.remove('k9-lofty--attention'),3200);
      };
      try{
        let started=Number(sessionStorage.getItem(firstKey)||0);
        if(!started){
          started=Date.now();
          sessionStorage.setItem(firstKey,String(started));
          bounce();
        }
        if(sessionStorage.getItem(reminderKey))return;
        window.setTimeout(()=>{
          if(sessionStorage.getItem(reminderKey))return;
          sessionStorage.setItem(reminderKey,'1');
          if(!root.classList.contains('k9-lofty--engaged')&&panel.hidden)bounce();
        },Math.max(0,started+reminderDelay-Date.now()));
        launcher.addEventListener('click',()=>sessionStorage.setItem(reminderKey,'1'),{once:true});
      }catch(e){bounce()}
    }

    function save(){
      try{
        sessionStorage.setItem(storageKey,JSON.stringify({
          service:state.service,
          location:state.location,
          history:state.history.slice(-12),
          transcript:state.transcript.slice(-40),
          pendingAvailability:state.pendingAvailability
        }));
      }catch(e){}
    }
    function scrollLog(){requestAnimationFrame(()=>{log.scrollTop=log.scrollHeight})}
    function open(){panel.hidden=false;launcher.setAttribute('aria-expanded','true');scrollLog();setTimeout(()=>input.focus({preventScroll:true}),30)}
    function shut(){panel.hidden=true;launcher.setAttribute('aria-expanded','false');launcher.focus()}
    launcher.addEventListener('click',()=>panel.hidden?open():shut());close.addEventListener('click',shut);document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden)shut()});
    // V371: on small screens the open panel covers the page, so close it when keyboard focus moves past it.
    root.addEventListener('focusout',e=>{if(panel.hidden||!e.relatedTarget||root.contains(e.relatedTarget))return;if(panel.getBoundingClientRect().width>window.innerWidth*0.8){panel.hidden=true;launcher.setAttribute('aria-expanded','false')}});

    function message(text,who='lofty',persist=true){
      const m=el('div','k9-lofty__message k9-lofty__message--'+who,text);
      log.appendChild(m);
      if(persist){state.transcript.push({type:'message',text,who});save()}
      scrollLog();
      return m;
    }
    function typingIndicator(){
      const m=el('div','k9-lofty__message k9-lofty__message--lofty k9-lofty__typing');
      m.setAttribute('role','status');
      m.setAttribute('aria-label','Lofty is typing');
      m.innerHTML='<span></span><span></span><span></span>';
      log.appendChild(m);
      scrollLog();
      return m;
    }
    function actions(items,persist=true){
      const box=el('div','k9-lofty__actions'),saved=[];
      const seen=new Set();
      items.forEach(item=>{
        const key=item.url?`${clean(item.label)}|${String(item.url).replace(/\/$/,'')}`:'';
        if(key&&seen.has(key))return;
        if(key)seen.add(key);
        const n=item.url?el('a','',item.label):el('button','',item.label);
        if(item.url){n.href=item.url;saved.push({label:item.label,url:item.url})}
        else{n.type='button';n.addEventListener('click',item.onClick)}
        box.appendChild(n);
      });
      log.appendChild(box);
      if(persist&&saved.length){state.transcript.push({type:'actions',items:saved});save()}
      scrollLog();
    }
    function restore(){
      try{
        const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
        if(!saved||typeof saved!=='object')return;
        state.service=typeof saved.service==='string'?saved.service:'';
        state.location=typeof saved.location==='string'?saved.location:'';
        state.history=Array.isArray(saved.history)?saved.history.slice(-12):[];
        state.transcript=Array.isArray(saved.transcript)?saved.transcript.slice(-40):[];
        state.pendingAvailability=typeof saved.pendingAvailability==='string'?saved.pendingAvailability:'';
        if(state.history.length||state.transcript.length)root.classList.add('k9-lofty--engaged');
        state.transcript.forEach(entry=>{
          if(entry&&entry.type==='message'&&typeof entry.text==='string')message(entry.text,entry.who==='user'?'user':'lofty',false);
          if(entry&&entry.type==='actions'&&Array.isArray(entry.items))actions(entry.items.filter(item=>item&&typeof item.label==='string'&&typeof item.url==='string'),false);
        });
      }catch(e){}
    }
    function visitUrl(){const u=new URL(page.plan,location.origin);if(state.service)u.searchParams.set('service',state.service);if(state.location)u.searchParams.set('location',state.location);u.searchParams.set('from','lofty');return u.pathname+u.search}
    function planAction(label='Plan a Visit'){actions([{label,url:visitUrl()}])}
    function detectLocation(q){
      const c=clean(q);
      if(/\becho park\b|\becho\b/.test(c))return 'echo-park';
      if(/\bsherman oaks\b|\bsherman\b/.test(c))return 'sherman-oaks';
      if(/\bpasadena\b/.test(c))return 'pasadena';
      return '';
    }
    function availabilityService(q){
      const c=clean(q);
      if(/\b(groom|grooming)\b/.test(c))return 'grooming';
      if(/\b(board|boarding)\b/.test(c))return 'boarding';
      if(/\bdental\b/.test(c))return 'dental';
      if(/\bdaycare\b/.test(c))return 'daycare';
      return '';
    }
    function isAvailabilityQuestion(q){
      const c=clean(q);
      if(/\b(open now|are you open|hours|opening hours|closing time)\b/.test(c))return false;
      const service=availabilityService(q);
      const timing=/\b(availability|available|appointment|appointments|slot|slots|opening|openings|earliest|latest|soonest|next available|book|booking|today|tomorrow|this weekend|weekend)\b/.test(c);
      return Boolean(service&&timing);
    }
    function availabilityContact(key){
      const data=locations[key],liveLoc=liveData&&liveData.locations?liveData.locations[key]:null;if(!data)return;
      state.location=key;save();
      const address=liveLoc&&liveLoc.address?liveLoc.address:'';
      const phone=(liveLoc&&liveLoc.phone)||data.phone||'';
      const sms=(liveLoc&&liveLoc.text)||data.sms||'';
      const email=(liveLoc&&liveLoc.email)||data.email||'';
      const service=state.pendingAvailability||'appointment';
      message(`For ${data.name}, the quickest way to check current ${service} availability is to contact the local team directly.`);
      const details=[address,phone?`Phone: ${phone}`:'',sms?`Text: ${sms}`:'',email?`Email: ${email}`:''].filter(Boolean).join(' • ');
      if(details)message(details);
      const list=[];
      if(sms)list.push({label:`Text ${data.name}`,url:`sms:${String(sms).replace(/\D/g,'')}`});
      if(phone)list.push({label:'Call',url:`tel:${String(phone).replace(/\D/g,'')}`});
      if(email)list.push({label:'Email',url:`mailto:${email}`});
      if(list.length)actions(list);
    }
    function chooseAvailabilityLocation(service){
      state.pendingAvailability=service||state.pendingAvailability||'appointment';save();
      message(`I can’t see live ${state.pendingAvailability} availability. Which K9 Loft location are you looking for?`);
      actions(Object.entries(locations).map(([key,data])=>({label:data.name,onClick:()=>{message(data.name,'user');availabilityContact(key)}})));
    }

    function chooseService(){
      message('What kind of day are you planning?');
      const services=[['Daycare','daycare'],['Boarding','boarding'],['Grooming','grooming'],['Dental cleaning','dental'],['Supplies','retail'],['I’m not sure','other']];
      actions(services.map(([label,key])=>({
        label,
        onClick:()=>{
          state.service=key;message(label,'user');
          if(key==='other'){
            message('No problem. Tell me a little about what you need, or choose your K9 Loft for a human handoff.');
            chooseLocation('handoff');
            return;
          }
          const copy={daycare:'Daycare is a fit for supervised play and a better dog day.',boarding:'Boarding is a fit for comfortable overnight care with daily play.',grooming:'Grooming is a fit for baths, tidy-ups, and haircuts.',dental:'Dental Clinic is a fit for non-anesthetic cleanings with a veterinarian present.',retail:'K9 Loft Shop offers pet supplies in store and online.'}[key];
          message(copy);
          if(key==='retail')actions([{label:'Shop online',url:'/collections/all'},{label:'Find a K9 Loft',url:'/pages/locations'}]);
          else chooseLocation('plan');
        }
      })));
    }
    function locationPage(key){return '/pages/'+key}
    function chooseLocation(next='handoff'){
      message('Which K9 Loft is closest to you?');
      actions(Object.entries(locations).map(([key,data])=>({label:data.name,onClick:()=>{
        state.location=key;message(data.name,'user');
        if(next==='plan'){planAction();return}
        if(next==='hours'){
          message(`You can see the current ${data.name} hours on its location page. Holiday closures and early-closing days follow K9 Loft’s posted holiday schedule.`);
          actions([{label:`View ${data.name} hours`,url:locationPage(key)},{label:`Text ${data.name}`,url:`sms:${String(data.sms||'').replace(/\D/g,'')}`}]);
          return;
        }
        handoff(key);
      }})));
    }
    function handoff(key){
      const data=locations[key];if(!data)return;
      message(`The ${data.name} team can help personally. Choose how you’d like to reach them.`);
      const sms=String(data.sms||'').replace(/\D/g,''),phone=String(data.phone||'').replace(/\D/g,'');
      actions([{label:`Text ${data.name}`,url:`sms:${sms}`},{label:'Call',url:`tel:${phone}`},{label:'Email',url:`mailto:${data.email}`},{label:'Plan a Visit',url:visitUrl()}]);
    }
    function clearAttachment(){
      state.pendingFile=null;state.attachmentDraft=null;state.attachmentStep='';if(fileInput)fileInput.value='';input.placeholder='Type your question…';
    }
    function renderTurnstile(node,key,attempt=0){
      if(!node||!document.documentElement.contains(node))return;
      if(window.turnstile){
        try{window.turnstile.render(node,{sitekey:key,theme:'light',size:'flexible',callback:token=>{if(state.attachmentDraft)state.attachmentDraft.turnstileToken=token;node.dispatchEvent(new CustomEvent('verified'))},'expired-callback':()=>{if(state.attachmentDraft)state.attachmentDraft.turnstileToken=''}});return}catch(e){}
      }
      if(attempt<50)setTimeout(()=>renderTurnstile(node,key,attempt+1),100);
    }
    function attachmentLocationPrompt(){
      if(!state.pendingFile||!state.attachmentDraft)return;
      state.attachmentStep='location';
      message(`Thanks. Which K9 Loft location should I send ${state.pendingFile.name} to for ${state.attachmentDraft.dogName}?`);
      actions(Object.entries(locations).map(([key,data])=>({label:data.name,onClick:()=>confirmAttachmentLocation(key)})));
    }
    function confirmAttachmentLocation(key){
      const data=locations[key];if(!data||!state.pendingFile)return;
      state.location=key;save();message(data.name,'user');
      state.attachmentStep='security';
      const siteKey=(root.dataset.turnstileSiteKey||'').trim();
      if(!siteKey){message('Secure attachment verification is not configured yet. Please use our Vaccine Records page for now.');clearAttachment();actions([{label:'Vaccine Records',url:page.vaccines}]);return}
      message('One last step: verifying your submission…');
      const verify=el('div','k9-lofty__turnstile');log.appendChild(verify);scrollLog();
      verify.addEventListener('verified',()=>{
        if(!state.pendingFile||state.attachmentStep!=='security')return;
        verify.remove();state.attachmentStep='confirm';
        const fileName=state.pendingFile.name,draft=state.attachmentDraft||{};
        message(`Send ${fileName} for ${draft.dogName||'your dog'} (${draft.customerName||'customer'}) to the ${data.name} team?`);
        actions([
          {label:'Yes, send it',onClick:()=>sendAttachment(key)},
          {label:'Cancel',onClick:()=>{clearAttachment();message('No problem. I won’t send the attachment.')}}
        ]);
      },{once:true});
      renderTurnstile(verify,siteKey);
    }
    async function sendAttachment(key){
      const file=state.pendingFile,draft=state.attachmentDraft||{},data=locations[key],endpoint=(root.dataset.endpoint||'').trim();
      if(!file||!data||!draft.turnstileToken)return;
      if(!endpoint){message('Attachment delivery isn’t connected yet. Please use the Vaccine Records page for now.');actions([{label:'Vaccine Records',url:page.vaccines}]);return}
      const wait=typingIndicator();
      try{
        const fd=new FormData();
        fd.append('action','send_attachment');
        fd.append('location',key);
        fd.append('attachment_type','vaccine_record');
        fd.append('customer_name',draft.customerName||'');
        fd.append('dog_name',draft.dogName||'');
        fd.append('pet_name',draft.dogName||'');
        fd.append('customer_email',draft.email||'');
        fd.append('turnstile_token',draft.turnstileToken||'');
        fd.append('file',file,file.name);
        fd.append('page_url',root.dataset.pageUrl||location.href);
        const res=await fetch(endpoint,{method:'POST',body:fd});
        const result=await res.json().catch(()=>({}));
        if(!res.ok||!result.ok){const err=new Error(result.message||result.error||'Attachment send failed');err.friendly=true;throw err}
        message(result.message||`Sent! Your attachment was emailed to the ${data.name} team.`);
        document.dispatchEvent(new CustomEvent('k9:vaccine-upload',{detail:{ok:true,location:key}}));
        clearAttachment();
      }catch(e){
        console.error('Lofty attachment error',e);
        document.dispatchEvent(new CustomEvent('k9:vaccine-upload',{detail:{ok:false,location:key}}));
        message(e&&e.friendly?e.message:'I couldn’t send that attachment right now. Please try again, or use our Vaccine Records page.');
        clearAttachment();
        actions([{label:'Vaccine Records',url:page.vaccines}]);
      }finally{wait.remove()}
    }
    function handleAttachment(file){
      if(!file)return;
      const allowed=new Set(['application/pdf','image/jpeg','image/png','image/webp']);
      const maxBytes=8*1024*1024;
      if(!allowed.has(file.type)){message('Please attach a PDF, JPG, PNG, or WebP vaccine record.');if(fileInput)fileInput.value='';return}
      if(file.size>maxBytes){message('That file is too large. Please choose a vaccine record under 8 MB.');if(fileInput)fileInput.value='';return}
      root.classList.add('k9-lofty--engaged');
      state.pendingFile=file;
      state.attachmentDraft={customerName:'',dogName:'',email:'',turnstileToken:''};
      state.attachmentStep='customer_name';
      message(`Attached: ${file.name}`,'user');
      message('Your vaccine record is attached. What is your name?');
      input.placeholder='Your name…';
      input.focus({preventScroll:true});
    }

    function score(item,q){
      const query=clean(q),stop=new Set(['the','and','are','you','your','our','for','with','what','when','where','who','why','how','does','can','could','would','should','have','has','there','this','that','from','about']);
      const terms=query.split(' ').filter(x=>x.length>2&&!stop.has(x));
      const hay=clean([item.topic,item.question,item.keywords].join(' '));
      const hayWords=new Set(hay.split(' ').filter(Boolean));
      let s=0;
      const question=clean(item.question);
      if(question&&query===question)s+=30;
      const topic=clean(item.topic);
      if(topic.length>3&&query.includes(topic))s+=8;
      if(/\b(price|pricing|cost|rate|rates)\b|how much/.test(query)&&/price|pricing/.test(topic))s+=15;
      String(item.keywords||'').split(',').map(clean).filter(Boolean).forEach(k=>{
        const words=k.split(' ').filter(Boolean);
        if(query.includes(k))s+=words.length>1?12:7;
        else if(words.length>1&&words.every(w=>terms.includes(w)))s+=8;
      });
      terms.forEach(t=>{if(hayWords.has(t))s+=2});
      return s;
    }
    function approved(q){return knowledge.map(item=>({item,score:score(item,q)})).sort((a,b)=>b.score-a.score)[0]}
    function localAnswer(q){
      const c=clean(q);
      if(/medical|emergency|vomit|bleed|seizure|diagnos|medicine|medication|injur/.test(c)){message('I can’t diagnose or advise on a medical concern. Please contact your veterinarian or an emergency veterinary provider. If your question is about K9 Loft care, I can connect you with your local team.');chooseLocation('handoff');return}
      if(/\b(open|opening|close|closing|hours)\b/.test(c)&&!/webcam|camera/.test(c)){
        const ctx=liveContext().business_status;if(ctx.is_closed_holiday){message(`K9 Loft is closed to the public today for ${ctx.holiday_name}.`)}else if(ctx.is_early_close){message(`K9 Loft is open today and closes at 6pm for ${ctx.holiday_name}.`)}else{message('K9 Loft is open 7am–9pm on weekdays and 9am–7pm on weekends.')}
        return;
      }
      if(/which service|right service|recommend|what do i need/.test(c)){chooseService();return}
      if(/human|person|team|text|call|contact/.test(c)){chooseLocation('handoff');return}
      const hit=approved(q);
      if(hit&&hit.score>=7){
        const answer=String(hit.item.answer||'').trim();message(answer);
        const list=[];
        if(hit.item.link&&(answer.length>220||/pricing|vaccines|plan a visit/i.test(String(hit.item.topic||''))))list.push({label:hit.item.link_label||'See full details',url:hit.item.link});
        if(/plan|visit|book|reservation|appointment/.test(c)){
          const target=visitUrl().replace(/\/$/,'');
          if(!list.some(item=>String(item.url||'').replace(/\/$/,'')===target||clean(item.label)==='plan a visit'))list.push({label:'Plan a Visit',url:visitUrl()});
        }
        if(list.length)actions(list);return
      }
      message('I don’t want to lead you down the wrong trail. I can help you choose a service, plan a visit, or connect with a local K9 Loft team.');actions([{label:'Find the right service',onClick:chooseService},{label:'Talk to my K9 Loft',onClick:()=>chooseLocation('handoff')}]);
    }
    function liveContext(){
      const now=new Date();
      const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',weekday:'long',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(now).reduce((o,p)=>(o[p.type]=p.value,o),{});
      let hour=Number(parts.hour||0);if(hour===24)hour=0;
      const minute=Number(parts.minute||0),year=Number(parts.year),month=Number(parts.month),day=Number(parts.day),weekday=parts.weekday;
      const weekend=weekday==='Saturday'||weekday==='Sunday';
      const nthWeekday=(y,m,weekdayIndex,n)=>{const d=new Date(Date.UTC(y,m-1,1));const delta=(weekdayIndex-d.getUTCDay()+7)%7;return 1+delta+(n-1)*7};
      const fourthThursday=nthWeekday(year,11,4,4),laborDay=nthWeekday(year,9,1,1);
      const isThanksgiving=month===11&&day===fourthThursday;
      const isDayBeforeThanksgiving=month===11&&day===fourthThursday-1;
      const closedHoliday=(month===1&&day===1)||(month===7&&day===4)||(month===9&&day===laborDay)||isThanksgiving||(month===12&&day===25);
      const earlyClose=isDayBeforeThanksgiving||(month===12&&(day===24||day===31));
      const openMin=weekend?9*60:7*60,normalClose=weekend?19*60:21*60,closeMin=closedHoliday?openMin:(earlyClose?18*60:normalClose),nowMin=hour*60+minute;
      const fmt=m=>{const h=Math.floor(m/60),min=m%60,ampm=h>=12?'pm':'am',h12=((h+11)%12)+1;return `${h12}${min?':'+String(min).padStart(2,'0'):''}${ampm}`};
      const holidayName=(month===1&&day===1)?'New Year’s Day':(month===7&&day===4)?'July 4':(month===9&&day===laborDay)?'Labor Day':isThanksgiving?'Thanksgiving Day':(month===12&&day===25)?'Christmas Day':isDayBeforeThanksgiving?'day before Thanksgiving':(month===12&&day===24)?'December 24':(month===12&&day===31)?'December 31':'';
      return Object.assign({},liveData,{current_time:{timezone:'America/Los_Angeles',weekday,date:`${parts.year}-${parts.month}-${parts.day}`,hour,minute,formatted:new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',weekday:'long',month:'long',day:'numeric',hour:'numeric',minute:'2-digit'}).format(now)},business_status:{is_open_now:!closedHoliday&&nowMin>=openMin&&nowMin<closeMin,is_closed_holiday:closedHoliday,is_early_close:earlyClose,holiday_name:holidayName,opens_at:closedHoliday?'Closed':fmt(openMin),closes_at:closedHoliday?'Closed':fmt(closeMin),standard_hours:weekend?'9am–7pm':'7am–9pm',holiday_hours:{closed:['New Year’s Day','July 4','Labor Day','Thanksgiving Day','Christmas Day'],close_at_6:['Day before Thanksgiving','December 24','December 31']}}});
    }
    async function ask(q){
      root.classList.add('k9-lofty--engaged');
      message(q,'user');state.history.push({role:'user',content:q});save();
      const endpoint=(root.dataset.endpoint||'').trim();if(!endpoint){localAnswer(q);return}
      form.setAttribute('aria-busy','true');
      const submit=form.querySelector('button[type="submit"]');if(submit)submit.disabled=true;input.disabled=true;
      try{
        const namedLocation=detectLocation(q);
        const availabilityQuery=isAvailabilityQuestion(q);
        if(availabilityQuery){
          const service=availabilityService(q);state.pendingAvailability=service;
          if(namedLocation){state.location=namedLocation;availabilityContact(namedLocation)}else chooseAvailabilityLocation(service);
          return;
        }
        if(namedLocation&&state.pendingAvailability){
          state.location=namedLocation;availabilityContact(namedLocation);return;
        }
        if(namedLocation)state.location=namedLocation;
        const locationForAI=namedLocation||'';
        const typing=typingIndicator();
        let res;
        try{
          res=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({message:q,history:state.history.slice(-6),knowledge,live:liveContext(),service:state.service,location:locationForAI,page:{title:root.dataset.pageTitle||document.title,url:root.dataset.pageUrl||location.href}})});
        }finally{
          typing.remove();
        }
        if(!res.ok)throw new Error('Request failed');const data=await res.json();message(data.answer||'I’m having trouble answering that right now.');state.history.push({role:'assistant',content:data.answer||''});save();
        const aiActions=Array.isArray(data.actions)?data.actions.filter(a=>{
          if(!a||typeof a.label!=='string'||typeof a.url!=='string')return false;
          if(attachmentsEnabled&&(/upload vaccine/i.test(a.label)||/vaccine-records/i.test(a.url)))return false;
          return true;
        }).slice(0,3):[];
        if(aiActions.length)actions(aiActions);
        const hasPlan=aiActions.some(a=>clean(a.label)==='plan a visit'||String(a.url||'').includes('/pages/request-a-visit'));
        if(data.needs_handoff)chooseLocation('handoff');else if(data.suggest_plan_visit&&!hasPlan&&/plan|book|reserve|reservation|appointment|schedule|request/.test(clean(q)))planAction();
      }catch(e){console.error('Lofty AI backend error',e);message('I’m having trouble reaching my AI service right now. Please try again in a moment.');}
      finally{form.removeAttribute('aria-busy');input.disabled=false;if(submit)submit.disabled=false;input.focus({preventScroll:true});}
    }
    const attachButton=qs(root,'.k9-lofty__attach');
    if(fileInput&&attachButton)attachButton.addEventListener('click',()=>fileInput.click());
    if(fileInput)fileInput.addEventListener('change',()=>handleAttachment(fileInput.files&&fileInput.files[0]));
    restore();
    setupAttentionBounce();
    form.addEventListener('submit',e=>{
      e.preventDefault();const q=input.value.trim();if(!q)return;input.value='';
      if(state.pendingFile&&state.attachmentStep==='customer_name'){
        message(q,'user');state.attachmentDraft.customerName=q.slice(0,100);state.attachmentStep='dog_name';message('And what is your dog’s name?');input.placeholder='Dog name…';input.focus({preventScroll:true});return;
      }
      if(state.pendingFile&&state.attachmentStep==='dog_name'){
        message(q,'user');state.attachmentDraft.dogName=q.slice(0,100);state.attachmentStep='email';message('What email address should the team use if they need to follow up?');input.placeholder='Email address…';input.focus({preventScroll:true});return;
      }
      if(state.pendingFile&&state.attachmentStep==='email'){
        message(q,'user');
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q)){message('Please enter a valid email address.');input.placeholder='Email address…';input.focus({preventScroll:true});return}
        state.attachmentDraft.email=q.slice(0,200);input.placeholder='Type your question…';attachmentLocationPrompt();return;
      }
      ask(q)
    });
    root.addEventListener('click',e=>{const b=e.target.closest('[data-question],[data-action]');if(!b)return;open();if(b.dataset.question)ask(b.dataset.question);if(b.dataset.action){root.classList.add('k9-lofty--engaged')}if(b.dataset.action==='recommend')chooseService();if(b.dataset.action==='handoff')chooseLocation('handoff');if(b.dataset.action==='ask')input.focus()});
  });
})();
